import runtimeConfig from '../../../../embedded-web2/src/embedding-framework/runtimeConfig';
import mockDataModel from './__mocks__';

export function getAngularDataModel() : any {
  return runtimeConfig.shouldMockAngular() ? mockDataModel : (window as any).dataModel;
}

export default getAngularDataModel();
